export default "__VITE_ASSET__gM12KnbQ__"